import { useContext } from "preact/hooks";
import { UnitsStoreContext } from "store/Units";

export const useUnitsStore = () => useContext(UnitsStoreContext);
